/* Judge.me has no Catalan widget locale. These are editorial UI labels only;
   customer review titles and bodies are intentionally never translated. */
(() => {
  const labels = new Map(Object.entries({
    'Reseñas de Clientes': 'Ressenyes de clients',
    'Reseñas de Productos': 'Ressenyes de productes',
    'Reseñas de productos': 'Ressenyes de productes',
    'Reseñas de la tienda': 'Ressenyes de la botiga',
    'Ver todas las reseñas': 'Veure totes les ressenyes',
    'Write a review': 'Escriu una ressenya',
    'Escribir una reseña': 'Escriu una ressenya',
    'Ordenar por': 'Ordena per',
    'Más Recientes': 'Més recents',
    'Mayor Calificación': 'Millor valoració',
    'Menor Calificación': 'Pitjor valoració',
    'Solo Imágenes': 'Només imatges',
    'Imágenes Primero': 'Imatges primer',
    'Videos Primero': 'Vídeos primer',
    'Más Útiles': 'Més útils',
    'Sin reseñas': 'Sense ressenyes',
    'No reviews': 'Sense ressenyes',
    'Reseña recopilada a través de una invitación al negocio': 'Ressenya recollida mitjançant una invitació de la botiga',
    'Verificado': 'Verificat',
    'Mostrar más': 'Mostra’n més',
    'Mostrar menos': 'Mostra’n menys',
  }));

  function translateText(value) {
    const trimmed = value.trim();
    if (!trimmed) return value;
    let translation = labels.get(trimmed);
    if (!translation) {
      const count = trimmed.match(/^(\d+)\s+(?:reseña|reseñas|review|reviews)$/i);
      if (count) translation = `${count[1]} ${Number(count[1]) === 1 ? 'ressenya' : 'ressenyes'}`;
    }
    if (!translation) {
      const summary = trimmed.match(/^Basado en (\d+) reseñas?$/i);
      if (summary) translation = `Basat en ${summary[1]} ${Number(summary[1]) === 1 ? 'ressenya' : 'ressenyes'}`;
    }
    if (!translation) {
      const rating = trimmed.match(/^Average rating is ([\d.,]+) stars?$/i);
      if (rating) translation = `Valoració mitjana: ${rating[1]} estrelles`;
    }
    if (!translation) {
      const reviewRating = trimmed.match(/^(\d+) star review$/i);
      if (reviewRating) translation = `Ressenya de ${reviewRating[1]} ${Number(reviewRating[1]) === 1 ? 'estrella' : 'estrelles'}`;
    }
    if (!translation) {
      const histogram = trimmed.match(/^(\d+% \(\d+\)) reviews with (\d+) star rating$/i);
      if (histogram) translation = `${histogram[1]} ressenyes amb ${histogram[2]} ${Number(histogram[2]) === 1 ? 'estrella' : 'estrelles'}`;
    }
    if (!translation) return value;
    return value.replace(trimmed, translation);
  }

  function translate(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      const parent = node.parentElement;
      if (!parent || parent.closest('.jdgm-rev__title, .jdgm-rev__body, .jdgm-rev__author, .jdgm-rev__timestamp, style, script')) continue;
      const translated = translateText(node.nodeValue);
      if (translated !== node.nodeValue) node.nodeValue = translated;
    }
    for (const element of root.querySelectorAll('[aria-label]')) {
      const value = element.getAttribute('aria-label');
      const translated = translateText(value);
      if (translated !== value) element.setAttribute('aria-label', translated);
    }
  }

  let scheduled = false;
  function refresh() {
    scheduled = false;
    document.querySelectorAll('.jdgm-widget, .jdgm-prev-badge').forEach(translate);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(refresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
